import { makeStyles } from "@material-ui/core/styles";

export const vehicleSelectorStyles = makeStyles((theme) => ({
    autoComplete: {
        backgroundColor: theme.palette.background.default,
        margin: '0.5rem 0',
        padding: '2px 0 2px 5px',
        color: theme.palette.primary.main,
        borderRadius: '4px',
        width: '100%',

        '&.MuiOutlinedInput-adornedEnd': {
            backgroundColor: theme.palette.background.default,
        },
        '&.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: '0 !important',
        },
        '&.MuiAutocomplete-inputRoot': {
            padding: '0 !important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '& fieldset': {
            border: 'none'
        },
        '& .MuiChip-root': {
            backgroundColor: 'white',
            borderRadius: '3px',
            color: theme.palette.primary.main,
            fontWeight: 400
        }
    },
    errorField: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: '1px solid red !important', // red border when error
            },
        },
    },
}));
